import Configs from "../config";

async function getVideoFromContext(contextTag: string) {
  try {
    const response: Response = await fetch(
      `https://api.berserkermail.com/help_video/${contextTag}`
    );

    if (response.status === 200) {
      const responseObject: { data: string } = await response.json();

      return responseObject.data;
    }

    return null;
  } catch (err) {
    return null;
  }
}

export const HelpVideoAPI = {
  getVideoFromContext,
};
